import { Component } from '@angular/core';
import { JackpotHrService } from '../jackpot-hr.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-jackpot-stats',
  templateUrl: './jackpot-stats.component.html',
  styleUrls: ['./jackpot-stats.component.scss'],
  standalone: true,
  imports: [CurrencyPipe, DecimalPipe],
})
export class JackpotStatsComponent {
  constructor(public jackpotService: JackpotHrService) {}
}
